import { useState } from "react";
import styled from "styled-components";
import theme from "../theme/theme";
import Tooltip from "./Base/Tooltip";
import FinacialAdvisorDetailsModal from "../components/FinacialAdvisorDetailsModal/FinacialAdvisorDetailsModal";
import {
  setFirstLogin,
  setGoalToLaunchPayload,
  setGoalToLaunch,
} from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { analytics } from "../analytics";
import { createPayload } from "../utils";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    display: inline-flex;
    align-items: center;
    font-size: 28px;
    color: ${theme.colors.primaryStrong};
  }

  @media (max-width: 480px) {
    margin-top: 5%;
    span {
      font-size: 20px;
    }
  }
`;

const StyledLink = styled.a`
  background-color: ${theme.colors.primaryStrong};
  border-color: ${theme.colors.primaryStrong};
  color: ${theme.colors.white};
  padding: 15px 65px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 4px;
  box-sizing: border-box;

  @media (max-width: 480px) {
    display: none;
  }

  &.disabled {
    pointer-events: none;
    background-color: ${theme.colors.gray1};
    border-color: ${theme.colors.gray1};
  }
`;

const goalNames = ["Retirement", "Major Purchase", "Education", "Build Wealth"];

const DashboardHeader = ({ btnDisabled, selectedOption }) => {
  const [isFinacialAdvisorModalVisible, setIsFinacialAdvisorModalVisible] =
    useState(false);
  const dispatch = useDispatch();
  const { goal, dashboardData, userAccountDetails } = useSelector(
    (state) => state.user
  );

  const getGoalData = (data) => {
    let goalTypeIndex, goalMonthly, goalTime, goalInitial, goalAmount;
    data.forEach((element) => {
      if (element.subject.replace(/[^\x00-\x7F]/g, "") === "Risk Profile") {
        goalTypeIndex = element.value;
      }
      if (element.subject === "Monthly Contribution") {
        goalMonthly = element.value;
      }
      if (
        element.subject === "Years Shown" ||
        element.subject === "Years Remaining" ||
        element.subject === "Retirement Age"
      ) {
        goalTime = element.value;
      }
      if (element.subject === "Initial Deposit") {
        goalInitial = element.value;
      }
      if (
        element.subject === "Goal Amount" ||
        element.subject === "Retirement Income Goal"
      ) {
        goalAmount = element.value;
      }
    });

    const goalRisks = [
      "Very Conservative",
      "Conservative",
      "Balanced",
      "Adventurous",
      "Very Adventurous",
    ];
    return {
      goalRisk: goalRisks[goalTypeIndex - 1],
      goalMonthly: goalMonthly,
      goalTime: goalTime,
      goalInitial: goalInitial || "NA",
      goalAmount: goalAmount || "NA",
    };
  };

  return (
    <>
      {isFinacialAdvisorModalVisible && (
        <FinacialAdvisorDetailsModal
          onClose={setIsFinacialAdvisorModalVisible}
          selectedOption={selectedOption}
        />
      )}
      <Wrapper>
        <span>
          Projected Portfolio Value
          <Tooltip
            className={`${window.screen.width > 480 ? "right" : "left"}`}
            text="The projected portfolio value is a range based on historical returns* and anticipated future performance. Returns are not guaranteed. Note - *historical returns are a blend of hypothetical and actual returns."
          />
        </span>
        <StyledLink
          // className={`${btnDisabled ? "disabled" : ""}`}
          // href="https://gdcdyn.interactivebrokers.com/Universal/Application"
          onClick={() => {
            const today = new Date();
            dispatch(setFirstLogin(false));
            analytics.track("Launch Requested", {
              userId: userAccountDetails?.id || "",
              goalId: goal?.id || "",
              goalType: goalNames[dashboardData?.yourGoal?.goal - 1],
              questionnaireUpdated: today.toLocaleString(),
              goalRisk:
                getGoalData(dashboardData?.settings?.additionalInfos)
                  .goalRisk || "",
              goalMonthly:
                getGoalData(dashboardData?.settings?.additionalInfos)
                  .goalMonthly || "",
              goalTime:
                getGoalData(dashboardData?.settings?.additionalInfos)
                  .goalTime || "",
              goalInitial:
                getGoalData(dashboardData?.settings?.additionalInfos)
                  .goalInitial || "",
              goalAmount:
                getGoalData(dashboardData?.settings?.additionalInfos)
                  .goalAmount || "",
            });
            if (userAccountDetails?.advisorPreference == null) {
              setIsFinacialAdvisorModalVisible(true);
            } else {
              dispatch(
                setGoalToLaunch(
                  createPayload(
                    dashboardData,
                    userAccountDetails?.advisorPreference,
                    userAccountDetails?.advisor,
                    goal
                  )
                )
              );
              dispatch(
                setGoalToLaunchPayload(
                  createPayload(
                    dashboardData,
                    userAccountDetails?.advisorPreference,
                    userAccountDetails?.advisor,
                    goal
                  )
                )
              );
            }
          }}
          target="_blank"
        >
          READY TO LAUNCH
        </StyledLink>
      </Wrapper>
    </>
  );
};

export default DashboardHeader;
